/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetProductDetails,
    GetAllGroups,
    GetProductCategoties,
    GetFactoriesByGroupID,
    GetProductsByFactoryIDProductcatogeryID,
    GetVCCFactoriesByGroupID,
    GetQuantityBoughtAgainstPurchaseOrderReportDetails,
    GetFDCFactoriesByGroupID
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryIDMultiSelect', 'factoryID=' + factoryID + '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetQuantityBoughtAgainstPurchaseOrderReportDetails(operationEntityID, productID, fromDate, toDate) {
    let model = {
        operationEntityID: operationEntityID,
        productID: productID,
        fromDate: fromDate,
        toDate: toDate
    }
    const response = await CommonPost('/api/FCCInboundTransactionsReportSKUwise/GetQtyBoughtAgainstPOReportDetails', null, model);
    return response.data;

}

async function GetFDCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/QuantityVarianceReport/GetFDCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

